import {
    Component,
    ElementRef,
    forwardRef,
    Host,
    Input,
    OnInit,
    Optional,
    SkipSelf,
    ViewChild,
} from '@angular/core';

import {ControlContainer, NG_VALUE_ACCESSOR} from '@angular/forms';

import {BaseComponent, BaseControl} from '../../classes';

@Component({
    selector: 'app-panel-input',
    templateUrl: './panel-input.component.html',
    styleUrls: ['./panel-input.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => PanelInputComponent),
        multi: true
    }]
})
export class PanelInputComponent extends BaseComponent<string | number, KeyboardEvent, BaseControl> implements OnInit {
    @ViewChild('input', {static: true}) inputReference: ElementRef;

    @Input() public disabled: boolean;

    constructor(
        @Optional() @Host() @SkipSelf()
        protected controlContainer: ControlContainer
    ) {
        super(controlContainer);
    }

    ngOnInit() {
        this.asFormsControl();
        this.checkInvalid();
    }

    toUpperCase(event: KeyboardEvent): void {
        if (/^[a-z]$/.test(event.key) && this.asFormsControl().upperCaseValue && !event.ctrlKey) {
            const selectionStart = (event.target as HTMLInputElement).selectionStart;
            const selectionEnd = (event.target as HTMLInputElement).selectionEnd;
            const isTextSelected = selectionStart !== selectionEnd;

            if (!isTextSelected) {
                const value = (event.target as HTMLInputElement).value;
                const valueLength = (event.target as HTMLInputElement).value.length;

                if (selectionEnd < valueLength) {
                    if (selectionEnd > 0) {
                        (event.target as HTMLInputElement).value = [
                            value.substring(0, selectionEnd),
                            event.key.toUpperCase(),
                            value.substring(selectionEnd)
                        ].join('');
                    } else {
                        (event.target as HTMLInputElement).value = event.key.toUpperCase() + value;
                    }

                    (event.target as HTMLInputElement).setSelectionRange(selectionEnd + 1, selectionEnd + 1);
                } else {
                    (event.target as HTMLInputElement).value = value + event.key.toUpperCase();
                }
            } else {
                (event.target as HTMLInputElement).value = event.key.toUpperCase();
            }

            event.preventDefault();
        }
    }

    changeValue(event: KeyboardEvent | ClipboardEvent): void {
        let value = '';

        if (event instanceof KeyboardEvent) {
            value = (event.target as HTMLInputElement).value;
        }

        if (event instanceof ClipboardEvent) {
            const clipboardData = event.clipboardData;

            value = clipboardData.getData('text');

            if (this.asFormsControl().upperCaseValue) {
                (event.target as HTMLInputElement).value = value = value.toUpperCase();

                event.preventDefault();
            }
        }

        this.onChange(value);
        this.checkInvalid();
        this.control.resetErrors();

        super.writeValue(value);
    }

    writeValue(value: string): void {
        this.inputReference.nativeElement.value = value;
        this.checkInvalid();
        this.control.resetErrors();

        super.writeValue(value);
    }

    asFormsControl(): BaseControl {
        if (!this.control) {
            this.control = new BaseControl({
                name: '',
                value: '',
                placeholder: '',
                validators: [],
                componentType: 0,
                invalid: false,
                errors: []
            });
        }

        return this.control;
    }
}
